/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutoSyncCounts } from './autoSyncCounts';

export interface BulkActionResponse {
  updated: number;
  auto_sync?: AutoSyncCounts | null;
  bulk_move_job_id?: string | null;
}
